import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomAlert from 'component/base/CustomAlert';
import { createAction } from 'utils';
import { deepLinkRootPath } from 'utils/WeChatUtil'
import i18n from 'utils/I18n';

function MyAccountLogout({

}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);

  const onConfirm = () => {
    history.push('/');
    dispatch(createAction('users/logout')({ onSuccess: () => deepLinkRootPath({ history }) }));
    setModalShow(false);
  }

  return (
    <Container className="common-shadow-section-container account-delete-account-section">
      <div className="common-section-title title-medium-2">
        {i18n.t('log_out')}
      </div>

      <button
        className="delete-button button-large"
        onClick={() => setModalShow(true)}
      >
        {i18n.t('account_logout')}
      </button>

      <CustomAlert
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={i18n.t("confirm_log_out")}
        leftbtn={i18n.t("log_out_cancel")}
        leftAction={() => setModalShow(false)}
        rightbtn={i18n.t("log_out")}
        rightAction={() => onConfirm()}
      />
    </Container>
  );
}


export default MyAccountLogout